import { URL } from "./url";

export const login = (user) => {
  return fetch(URL.token, {
    method: "post",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(user),
  })
    .then((res) => {
      if (!res.ok) throw new Error(res.statusText);
      return res.json();
    })
    .then((tokens) => {
      // refresh token 由後端寫進 httpOnly cookie，body 只有 access
      if (tokens.access) {
        localStorage.setItem("user", JSON.stringify({ access: tokens.access }));
      }
      return tokens;
    });
};

// single-flight：多分頁/多請求同時觸發 refresh 時共用同一個請求，
// 避免 rotation 開啟後併發換發互相 blacklist
let refreshInflight = null;

const doRefresh = async () => {
  const user = localStorage.getItem("user");
  if (!user) throw new Error("user not found");

  let parsed;
  try {
    parsed = JSON.parse(user);
  } catch {
    throw new Error("invalid user");
  }

  // 過渡期：localStorage 若殘留舊版 refresh token 就帶上（body fallback），
  // 否則空 body，由瀏覽器自動帶 httpOnly cookie
  const { refresh } = parsed;
  const res = await fetch(URL.refresh, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(refresh ? { refresh } : {}),
  });
  if (!res.ok) throw new Error(res.statusText);
  const { access } = await res.json();
  const tokens = { access };
  localStorage.setItem("user", JSON.stringify(tokens));
  return tokens;
};

export const refresh = () => {
  if (!refreshInflight) {
    refreshInflight = doRefresh().finally(() => {
      refreshInflight = null;
    });
  }
  return refreshInflight;
};

export const logout = () => {
  // 通知後端 blacklist refresh token 並清 cookie；失敗不影響本地登出
  fetch(URL.logout, { method: "POST" }).catch(() => {});
  localStorage.removeItem("user");
  return {};
};
